import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { Button, Container, Grid, Icon, Typography } from '@mui/material';
import DropdownMenu from '../elements/DropdownMenu';

const Filters = ({ registryData, type, setType, price, setPrice }) => {
  const commonButtonStyle = {
    width: { xs: '130px', md: '180px' },
    height: '44px',
    textTransform: 'none',
    border: '1px solid #000000',
    borderRadius: '60px',
    '&& .css-1d3z3hw-MuiOutlinedInput-notchedOutline': {
      border: 'var(--Black, #000)',
    },
    ml: { md: '24px' },
    p: '10px 24px',
    fontSize: { xs: '14px', sm: '16px' },
  };

  const buttonStyle = {
    selected: {
      backgroundColor: '#000000',
      color: '#FFFFFF',
      '&:hover': {
        backgroundColor: '#000000',
      },
      ...commonButtonStyle,
    },
    notSelected: {
      backgroundColor: 'transparent',
      color: '#000000',
      '&:hover': {
        backgroundColor: 'transparent',
      },
      ...commonButtonStyle,
    },
  };

  return (
    <Container>
      <Grid container>
        <Grid item xs={12}>
          <Typography sx={{ fontSize: 32, textAlign: 'center', mt: 4 }}>
            {registryData?.head_line ? registryData.head_line : 'Our registry'}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        justifyContent="center"
        xs={12}
        gap={{ xs: '24px', md: '0px' }}
        sx={{ mt: { xs: '40px', md: '24px' } }}>
        <Grid item sx={{ display: 'flex', alignItems: 'center' }}>
          <Button
            sx={{
              ...(type === 'available'
                ? buttonStyle.selected
                : buttonStyle.notSelected),
              mr: { xs: '24px', md: '0px' },
              ml: 0,
            }}
            onClick={() => {
              setType('available');
            }}>
            Available
          </Button>

          <Button
            sx={{
              ...(type === 'purchased'
                ? buttonStyle.selected
                : buttonStyle.notSelected),
            }}
            onClick={() => {
              setType('purchased');
              setPrice(' ');
            }}>
            Purchased
          </Button>
        </Grid>
        <Grid item>
          <DropdownMenu
            value={price}
            disabled={type === 'purchased'}
            onChangeAction={(e) => setPrice(e.target.value)}
            options={[
              { value: ' ', label: 'Filter by price' },
              { value: '-50', label: 'Under $50' },
              { value: '50-100', label: '$50 - $100' },
              { value: '100-200', label: '$100 - $200' },
              { value: '200-', label: '$200+' },
            ]}
            elementName="price"
            sx={{
              ...commonButtonStyle,
              borderRadius: '60px',
              background: 'var(--White, #FFF)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: { xs: '280px', md: '380px' },
              padding: 0,
            }}
            endIcon={<Icon component={ArrowDropDownIcon} />}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default Filters;
